import DOMPurify from 'dompurify';

const sanitizePurify = (dirtyHtml: string) => {
    return DOMPurify.sanitize(dirtyHtml);
}

export { sanitizePurify };

